// @core/api/endpoints/billing/list_billing_products.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListBillingProductsResponse,
} from '../../../types/billing';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/billing';

/**
 * List products
 * Returns a paginated list of products with optional filtering by active status. Includes all billable items available for invoicing.
 */
export async function ListBillingProducts(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListBillingProductsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/products`;
  const requestOptions = options;
  return client.get<ListBillingProductsResponse>(requestPath, { ...requestOptions, params });
}
